import { useState } from 'react'

import ContentBanner from './contentbanner/ContentBanner'
import ContentData from './contentdata/ContentData'
import Modal from './modal/Modal.jsx'

import './content.css'
import UserAppContext from '../hook/UserAppContext'

const Content = () => {

      const [modal, setModal] = useState(false)
      const {user} = UserAppContext()

      if(user.length === 0) return

      const {videos} = user.user
      
      return (
            <div className="content">
                  <Modal videos={videos} isModal={modal} isSetModal={setModal} />
                  <ContentBanner />
                  <ContentData isSetModal={setModal}/>
            </div>
      )
}

export default Content;